export const SET_PAYMENT_INFO = 'SET_PAYMENT_INFO'